import { render, staticRenderFns } from "./CitySelect.vue?vue&type=template&id=797045ea&scoped=true"
import script from "./CitySelect.vue?vue&type=script&lang=js"
export * from "./CitySelect.vue?vue&type=script&lang=js"
import style0 from "./CitySelect.vue?vue&type=style&index=0&id=797045ea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797045ea",
  null
  
)

export default component.exports